import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const translations = {
  fr: {
    app_name: "MetalVault",
    tagline: "Votre annuaire personnel metal & rock",
    login: "Connexion", register: "Créer un compte", logout: "Déconnexion",
    email: "Email", password: "Mot de passe", name: "Nom",
    google_login: "Continuer avec Google",
    no_account: "Pas encore de compte ?", have_account: "Déjà un compte ?",
    directory: "Annuaire", calendar: "Calendrier", add_band: "Ajouter un groupe",
    search_band: "Rechercher un groupe...", all: "Tous", metal: "Metal", rock: "Rock",
    no_bands: "Aucun groupe pour l'instant. Ajoutez votre premier groupe !",
    band_name: "Nom du groupe / artiste", category: "Catégorie", genre: "Genre",
    subgenre: "Sous-genre", country: "Pays", rating: "Évaluation",
    members: "Membres actuels", albums: "Albums préférés", notes: "Notes (format libre)",
    links: "Liens", official_site: "Site officiel", wikipedia: "Wikipédia", deezer: "Deezer",
    autofill: "Remplissage automatique", autofill_hint: "Saisissez le nom puis lancez la recherche automatique",
    fetch_info: "Rechercher les infos", save: "Enregistrer", cancel: "Annuler",
    delete: "Supprimer", edit: "Modifier", added_on: "Ajouté le",
    concerts_seen: "Concerts vus", instruments: "Instruments",
    add_album: "Ajouter un album", add_member: "Ajouter un membre",
    events: "Événements", add_event: "Ajouter un événement", event_name: "Nom de l'événement",
    type: "Type", concert: "Concert", festival: "Festival",
    start_date: "Date de début", end_date: "Date de fin", location: "Lieu",
    comment: "Commentaire", no_events: "Aucun événement. Ajoutez votre premier concert ou festival !",
    event_detail: "Détail de l'événement", artists_seen: "Artistes vus à cet événement",
    add_concert: "Ajouter un concert", select_band: "Sélectionner un groupe",
    event_url: "Lien Internet (URL)", open_link: "Ouvrir le lien", select_event: "Sélectionner un événement",
    add_concert_here: "Ajouter un concert",
    existing_event: "Événement existant", new_event: "Nouvel événement",
    attended_label: "Concert vu ?", attended_yes: "Vu", attended_no: "Pas vu",
    mark_seen: "Marquer comme vu", mark_not_seen: "Marquer comme non vu",
    concerts_filter: "Concerts :", filter_attended: "Vus", filter_missed: "Ratés", filter_all: "Tous",
    concerts_missed_label: "Concerts ratés", concerts_all_label: "Concerts (tous)",
    concerts_seen_of: "vus", concerts_planned: "prévus",
    no_concerts: "Aucun concert enregistré pour cet événement.",
    fetching: "Recherche en cours...", saving: "Enregistrement...",
    confirm_delete: "Confirmer la suppression ?", logo: "Logo",
    back: "Retour", view: "Voir", date: "Date",
    bands_count: "groupes", concert_count: "concerts",
    search_placeholder_event: "ex : Hellfest 2026",
    upload_logo: "Importer un logo", uploading: "Import en cours...",
    no_auto_logo: "Aucun logo trouvé automatiquement — importez-en un.",
    stats: "Statistiques", export: "Exporter", share: "Partager",
    total_bands: "Groupes", total_events: "Événements", total_concerts: "Concerts vus",
    by_genre: "Groupes par genre", by_category: "Répartition Metal / Rock",
    by_country: "Groupes par pays", concerts_by_year: "Concerts par an", top_rated: "Mieux notés",
    top_seen: "Groupes les plus vus", no_seen_yet: "Aucun concert vu pour l'instant.", seen_list: "Vus", missed_list: "Ratés",
    seen_at_events: "événement(s) où vous l'avez vu",
    share_title: "Partager mon annuaire", share_desc: "Toute personne disposant de ce lien pourra consulter votre annuaire en lecture seule.",
    generate_link: "Générer un lien", copy: "Copier", copied: "Copié !", revoke: "Révoquer le lien",
    public_collection: "Annuaire public", powered_by: "Propulsé par MetalVault",
    no_stats: "Ajoutez des groupes pour voir vos statistiques.",
    suggestions: "Suggestions", export_done: "Annuaire exporté",
    settings: "Réglages", account: "Compte", security: "Sécurité",
    change_password: "Changer le mot de passe", current_password: "Mot de passe actuel",
    new_password: "Nouveau mot de passe", password_changed: "Mot de passe modifié",
    mfa: "Double authentification (MFA)", enable_mfa: "Activer le MFA", disable_mfa: "Désactiver le MFA",
    mfa_on: "MFA activé", mfa_off: "MFA désactivé",
    scan_qr: "Scannez ce QR code avec Google Authenticator, puis saisissez le code à 6 chiffres.",
    mfa_secret_manual: "Clé manuelle :", enter_code: "Code à 6 chiffres", verify: "Vérifier",
    preferred_platform: "Plateforme de streaming préférée", save_preferences: "Enregistrer",
    preferences_saved: "Préférences enregistrées",
    import: "Importer", import_directory: "Importer un annuaire (JSON)",
    import_desc: "Restaurez ou transférez votre annuaire depuis un fichier d'export.", import_done: "Import terminé",
    import_excel: "Importer Excel / CSV", import_excel_desc: "Importez des groupes, événements et concerts depuis un fichier .xlsx (3 feuilles) ou .csv (une entité). Les en-têtes doivent correspondre à l'export.",
    import_file: "Choisir un fichier",
    download_template: "Télécharger le modèle",
    import_preview_title: "Aperçu de l'import", import_preview_desc: "Voici ce qui sera ajouté à votre annuaire. Confirmez pour importer.",
    import_skipped: "Concerts ignorés (groupe ou événement introuvable)", import_confirm: "Confirmer l'import", cancel: "Annuler",
    contact_us: "Nous contacter", contact_title: "Nous contacter", contact_subject: "Objet", contact_message: "Message",
    contact_send: "Envoyer", contact_sent: "Message envoyé, merci !", contact_desc: "Une question, un bug, une suggestion ? Écrivez-nous.",
    contact_category: "Catégorie", cat_bug: "Bug", cat_suggestion: "Suggestion", cat_question: "Question",
    forgot_password: "Mot de passe oublié ?", reset_password: "Réinitialiser le mot de passe",
    send_reset_link: "Générer le lien", reset_link_generated: "Lien généré — copiez-le et ouvrez-le pour réinitialiser :",
    copy_link: "Copier le lien", back_to_login: "Retour à la connexion", mfa_code_label: "Code d'authentification",
    admin: "Admin", users_label: "Utilisateurs", role: "Rôle", status: "Statut",
    blocked_label: "Bloqué", active: "Actif", block: "Bloquer", unblock: "Débloquer",
    delete_account: "Supprimer", confirm_block: "Bloquer ce compte ?", confirm_unblock: "Débloquer ce compte ?",
    confirm_delete_user: "Supprimer définitivement ce compte et toutes ses données ?", no_users: "Aucun utilisateur.",
    streaming: "Plateformes de streaming", listen_on: "Écouter sur", apple_music: "Apple Music",
    youtube_music: "YouTube Music", bandcamp: "Bandcamp", spotify: "Spotify",
    edit_event: "Modifier l'événement", event_updated: "Événement mis à jour", save_event: "Enregistrer",
    search_event: "Rechercher par nom ou date...", band_info: "Informations du groupe",
    grid_view: "Vue vignettes", list_view: "Vue liste",
    sort_by: "Trier", sort_recent: "Plus récents", sort_oldest: "Plus anciens",
    sort_az: "Nom (A→Z)", sort_za: "Nom (Z→A)",
    sort_rating_desc: "Note (élevée→basse)", sort_rating_asc: "Note (basse→élevée)",
    sort_date_desc: "Date (récent→ancien)", sort_date_asc: "Date (ancien→récent)",
    photos: "Photos du concert", add_photo: "Ajouter une photo", no_photos: "Aucune photo. Ajoutez-en une si vous en avez !",
    photo_uploaded: "Photo ajoutée", delete_photo: "Supprimer la photo", export_excel: "Excel",
    heatmap: "Activité concerts", heatmap_year: "Année", heatmap_less: "Moins", heatmap_more: "Plus",
    advanced_filters: "Filtres avancés", filter_genre: "Genre", filter_country: "Pays",
    filter_rating: "Note minimale", all_countries: "Tous les pays", clear_filters: "Réinitialiser", filter_seen_only: "Vus en concert",
    no_results: "Aucun résultat pour ces filtres.", prev_page: "Précédent", next_page: "Suivant", page_label: "Page",
    install_app: "Installer l'app", update_app: "Mettre à jour", install_title: "Installer MetalVault",
    install_ios_1: "Touchez le bouton Partager", install_ios_2: "Choisissez", install_ios_add: "Sur l'écran d'accueil",
    install_ios_3: "Confirmez : MetalVault apparaîtra comme une app sur votre écran d'accueil.",
    install_other_1: "Ouvrez le menu de votre navigateur (⋮) puis choisissez « Installer l'application » ou « Ajouter à l'écran d'accueil ».",
    install_other_2: "Si l'option n'apparaît pas, votre navigateur ne supporte peut-être pas l'installation. Essayez Chrome (Android) ou Safari (iOS).",
    install_benefit: "Accès rapide, plein écran, comme une vraie app.", close: "Fermer",
    app_version: "Version", update_available: "Mise à jour disponible",
  },
  en: {
    app_name: "MetalVault",
    tagline: "Your personal metal & rock directory",
    login: "Login", register: "Create account", logout: "Logout",
    email: "Email", password: "Password", name: "Name",
    google_login: "Continue with Google",
    no_account: "No account yet?", have_account: "Already have an account?",
    directory: "Directory", calendar: "Calendar", add_band: "Add a band",
    search_band: "Search a band...", all: "All", metal: "Metal", rock: "Rock",
    no_bands: "No bands yet. Add your first band!",
    band_name: "Band / artist name", category: "Category", genre: "Genre",
    subgenre: "Subgenre", country: "Country", rating: "Rating",
    members: "Current members", albums: "Favorite albums", notes: "Notes (free form)",
    links: "Links", official_site: "Official site", wikipedia: "Wikipedia", deezer: "Deezer",
    autofill: "Auto-fill", autofill_hint: "Enter the name then run the automatic lookup",
    fetch_info: "Fetch info", save: "Save", cancel: "Cancel",
    delete: "Delete", edit: "Edit", added_on: "Added on",
    concerts_seen: "Concerts seen", instruments: "Instruments",
    add_album: "Add an album", add_member: "Add a member",
    events: "Events", add_event: "Add an event", event_name: "Event name",
    type: "Type", concert: "Concert", festival: "Festival",
    start_date: "Start date", end_date: "End date", location: "Location",
    comment: "Comment", no_events: "No events. Add your first concert or festival!",
    event_detail: "Event detail", artists_seen: "Artists seen at this event",
    add_concert: "Add a concert", select_band: "Select a band",
    event_url: "Web link (URL)", open_link: "Open link", select_event: "Select an event",
    add_concert_here: "Add a concert",
    existing_event: "Existing event", new_event: "New event",
    attended_label: "Concert attended?", attended_yes: "Seen", attended_no: "Missed",
    mark_seen: "Mark as seen", mark_not_seen: "Mark as not seen",
    concerts_filter: "Concerts:", filter_attended: "Seen", filter_missed: "Missed", filter_all: "All",
    concerts_missed_label: "Missed concerts", concerts_all_label: "Concerts (all)",
    concerts_seen_of: "seen", concerts_planned: "planned",
    no_concerts: "No concert recorded for this event.",
    fetching: "Searching...", saving: "Saving...",
    confirm_delete: "Confirm deletion?", logo: "Logo",
    back: "Back", view: "View", date: "Date",
    bands_count: "bands", concert_count: "concerts",
    search_placeholder_event: "e.g. Hellfest 2026",
    upload_logo: "Upload a logo", uploading: "Uploading...",
    no_auto_logo: "No logo found automatically — upload one.",
    stats: "Statistics", export: "Export", share: "Share",
    total_bands: "Bands", total_events: "Events", total_concerts: "Concerts seen",
    by_genre: "Bands by genre", by_category: "Metal / Rock split",
    by_country: "Bands by country", concerts_by_year: "Concerts per year", top_rated: "Top rated",
    top_seen: "Most seen bands", no_seen_yet: "No concert seen yet.", seen_list: "Seen", missed_list: "Missed",
    seen_at_events: "event(s) where you saw them",
    share_title: "Share my directory", share_desc: "Anyone with this link can view your directory in read-only mode.",
    generate_link: "Generate a link", copy: "Copy", copied: "Copied!", revoke: "Revoke link",
    public_collection: "Public directory", powered_by: "Powered by MetalVault",
    no_stats: "Add some bands to see your statistics.",
    suggestions: "Suggestions", export_done: "Directory exported",
    settings: "Settings", account: "Account", security: "Security",
    change_password: "Change password", current_password: "Current password",
    new_password: "New password", password_changed: "Password changed",
    mfa: "Two-factor authentication (MFA)", enable_mfa: "Enable MFA", disable_mfa: "Disable MFA",
    mfa_on: "MFA enabled", mfa_off: "MFA disabled",
    scan_qr: "Scan this QR code with Google Authenticator, then enter the 6-digit code.",
    mfa_secret_manual: "Manual key:", enter_code: "6-digit code", verify: "Verify",
    preferred_platform: "Preferred streaming platform", save_preferences: "Save",
    preferences_saved: "Preferences saved",
    import: "Import", import_directory: "Import a directory (JSON)",
    import_desc: "Restore or transfer your directory from an export file.", import_done: "Import complete",
    import_excel: "Import Excel / CSV", import_excel_desc: "Import bands, events and concerts from a .xlsx file (3 sheets) or .csv (single entity). Headers must match the export.",
    import_file: "Choose a file",
    download_template: "Download template",
    import_preview_title: "Import preview", import_preview_desc: "Here is what will be added to your directory. Confirm to import.",
    import_skipped: "Skipped concerts (band or event not found)", import_confirm: "Confirm import", cancel: "Cancel",
    contact_us: "Contact us", contact_title: "Contact us", contact_subject: "Subject", contact_message: "Message",
    contact_send: "Send", contact_sent: "Message sent, thank you!", contact_desc: "A question, a bug, a suggestion? Drop us a line.",
    contact_category: "Category", cat_bug: "Bug", cat_suggestion: "Suggestion", cat_question: "Question",
    forgot_password: "Forgot password?", reset_password: "Reset password",
    send_reset_link: "Generate link", reset_link_generated: "Link generated — copy and open it to reset:",
    copy_link: "Copy link", back_to_login: "Back to login", mfa_code_label: "Authentication code",
    admin: "Admin", users_label: "Users", role: "Role", status: "Status",
    blocked_label: "Blocked", active: "Active", block: "Block", unblock: "Unblock",
    delete_account: "Delete", confirm_block: "Block this account?", confirm_unblock: "Unblock this account?",
    confirm_delete_user: "Permanently delete this account and all its data?", no_users: "No users.",
    streaming: "Streaming platforms", listen_on: "Listen on", apple_music: "Apple Music",
    youtube_music: "YouTube Music", bandcamp: "Bandcamp", spotify: "Spotify",
    edit_event: "Edit event", event_updated: "Event updated", save_event: "Save",
    search_event: "Search by name or date...", band_info: "Band info",
    grid_view: "Grid view", list_view: "List view",
    sort_by: "Sort", sort_recent: "Most recent", sort_oldest: "Oldest",
    sort_az: "Name (A→Z)", sort_za: "Name (Z→A)",
    sort_rating_desc: "Rating (high→low)", sort_rating_asc: "Rating (low→high)",
    sort_date_desc: "Date (newest→oldest)", sort_date_asc: "Date (oldest→newest)",
    photos: "Concert photos", add_photo: "Add a photo", no_photos: "No photo yet. Add one if you have it!",
    photo_uploaded: "Photo added", delete_photo: "Delete photo", export_excel: "Excel",
    heatmap: "Concert activity", heatmap_year: "Year", heatmap_less: "Less", heatmap_more: "More",
    advanced_filters: "Advanced filters", filter_genre: "Genre", filter_country: "Country",
    filter_rating: "Min rating", all_countries: "All countries", clear_filters: "Reset", filter_seen_only: "Seen live",
    no_results: "No results for these filters.", prev_page: "Previous", next_page: "Next", page_label: "Page",
    install_app: "Install app", update_app: "Update", install_title: "Install MetalVault",
    install_ios_1: "Tap the Share button", install_ios_2: "Choose", install_ios_add: "Add to Home Screen",
    install_ios_3: "Confirm: MetalVault will appear as an app on your home screen.",
    install_other_1: "Open your browser menu (⋮) then choose “Install app” or “Add to Home screen”.",
    install_other_2: "If you don't see the option, your browser may not support installation. Try Chrome (Android) or Safari (iOS).",
    install_benefit: "Fast access, full screen, just like a native app.", close: "Close",
    app_version: "Version", update_available: "Update available",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mv_lang") || "fr");
  useEffect(() => { localStorage.setItem("mv_lang", lang); }, [lang]);
  const t = useCallback((key) => translations[lang][key] || key, [lang]);
  const toggle = () => setLang((l) => (l === "fr" ? "en" : "fr"));
  return <LangContext.Provider value={{ lang, setLang, toggle, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
